export const MODAL_BODY_STYLES: React.CSSProperties = {
  maxHeight: '90vh',
  overflowY: 'auto',
};

export enum OpeningHoursText {
  allDay = '24小時開放',
  closed = '非開放',
  unset = '尚未設定',
}
